export default __webpack_public_path__ + "static/media/Snd_TryF.6701a8f2.mp3";